"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDocStopPoisQuerySchema = exports.DocStopPoiSchema = void 0;
const zod_1 = require("zod");
const poi_type_1 = require("./poi-type");
/**
 * A DocStop doctor or servicepoint. Fully independent of `RestArea` — never counted
 * in parking-spot search/listing or availability. `category` doubles as the doctor's
 * medical specialty ("Fachrichtung") and the servicepoint's category.
 */
exports.DocStopPoiSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: poi_type_1.PoiTypeSchema,
    name: zod_1.z.string(),
    category: zod_1.z.string().nullable(),
    lat: zod_1.z.number(),
    lon: zod_1.z.number(),
    address: zod_1.z.string().nullable(),
    country: zod_1.z.string().nullable(),
    phone: zod_1.z.string().nullable(),
    phoneMobile: zod_1.z.string().nullable(),
    phoneEmergency: zod_1.z.string().nullable(),
    email: zod_1.z.string().nullable(),
    homepage: zod_1.z.string().nullable(),
    openingHours: zod_1.z.string().nullable(),
    /** Autobahn designation, e.g. "A7" (Bundesautobahn). */
    bab: zod_1.z.string().nullable(),
    exitName: zod_1.z.string().nullable(),
    exitNumber: zod_1.z.string().nullable(),
    /** Freetext parking instruction (doctors) or general note (servicepoints), shown verbatim. */
    note: zod_1.z.string().nullable(),
    /** Raw "Verlinkter Servicepoint" text from the source column, shown verbatim — not resolved to a POI. */
    linkedPoiPlace: zod_1.z.string().nullable(),
    isActive: zod_1.z.boolean(),
});
exports.GetDocStopPoisQuerySchema = zod_1.z.object({
    types: zod_1.z
        .string()
        .optional()
        .transform((value) => (value ? value.split(',').map((entry) => entry.trim()) : undefined))
        .pipe(zod_1.z.array(poi_type_1.PoiTypeSchema).optional()),
});
//# sourceMappingURL=docStop-poi.js.map